// @flow

import React from 'react';
import Image from '../util/Image';
import classnames from 'classnames';

import styles from './ArtistAvatar.css';
import { IMGIX_BASE_URL, PROFILE_IMAGE_DIMS } from '../../lib/imgix';
import ContentfulImage from '../util/ContentfulImage';

type SharedProps = {
  className: string,
  size: number,
};

type ImageSrcProps = {
  src?: string, // contentful images
};

type ProfileIdProps = {
  profileId?: number, // idagio service images
};

type OwnProps = SharedProps & ImageSrcProps & ProfileIdProps;

type Props = OwnProps;

const ArtistAvatar = ({ profileId, src, className, size = PROFILE_IMAGE_DIMS.w }: Props) => {
  const classNames = classnames(className, styles.avatar);

  if (profileId) {
    return (
      <Image
        src={`/artists/${profileId}/main.jpg`}
        width={size}
        height={size}
        className={classNames}
        alt=""
      />
    );
  }

  if (src && !src.startsWith(IMGIX_BASE_URL)) {
    return (
      <ContentfulImage
        src={src}
        className={classNames}
        options={{
          fit: 'thumb',
          f: 'face',
          h: size,
          w: size,
        }}
        alt=""
      />
    );
  }

  return null;
};

export default ArtistAvatar;
